import React from 'react';
import { Chevron } from '@solent-university/solent-icons';

import { Props as LinkProps } from 'Elements/Link';

import Image, { StaticImageData } from 'next/image';
import { Wrapper, ImageContainer, Label, IconStyled } from './OverlayImage.styled';

export type Padding = 'thin' | 'tall' | undefined;

export interface Props {
    text: string;
    link: LinkProps;
    backgroundImage: {
        src: StaticImageData | string;
        alt?: string;
    };
    backgroundColour?: string;
    padding?: Padding;
    className?: string;
}

const OverlayImage: React.FC<Props> = props => {
    const { text, link, backgroundImage, backgroundColour, padding = undefined, className } = props;

    return (
        <Wrapper {...link} $padding={padding} className={className}>
            <ImageContainer $backgroundColour={backgroundColour}>
                <Image
                    src={backgroundImage.src}
                    alt={backgroundImage.alt || ''}
                    fill
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
            </ImageContainer>
            <Label>{text}</Label>
            <IconStyled icon={Chevron} />
        </Wrapper>
    );
};

export default OverlayImage;
